import React from "react";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

const OfferCard = ({ offer, showPricing = false }) => {
  const { t } = useLanguage();
  const Icon = offer.icon;

  return (
    <article
      id={offer.id}
      className={`ws-offer-card${offer.featured ? " ws-offer-card--featured" : ""}`}
    >
      {offer.featured && <span className="ws-offer-card__badge">WonyaPay</span>}
      <div className="ws-offer-card__icon" aria-hidden="true">
        <Icon size={26} strokeWidth={1.9} />
      </div>
      <span className="ws-offer-card__label">{t(offer.label)}</span>
      <h3>{t(offer.title)}</h3>
      <p className="ws-offer-card__description">{t(offer.description)}</p>
      <ul className="ws-offer-card__benefits">
        {offer.benefits.map((benefit) => (
          <li key={benefit}>
            <Check size={17} aria-hidden="true" />
            <span>{t(benefit)}</span>
          </li>
        ))}
      </ul>
      {showPricing && (
        <div className="ws-offer-card__pricing">
          <span>{t("Tarification")}</span>
          {offer.pricingDetails ? (
            <div className="ws-offer-card__pricing-details">
              {offer.pricingDetails.map(({ label, value }) => (
                <div key={label}>
                  <small>{t(label)}</small>
                  <strong>{t(value)}</strong>
                </div>
              ))}
            </div>
          ) : (
            <strong>{t(offer.pricing)}</strong>
          )}
        </div>
      )}
      {offer.disabled ? (
        <div
          className="ws-offer-card__action"
          aria-disabled="true"
        >
          <span>{t(offer.action)}</span>
          <ArrowRight size={18} aria-hidden="true" />
        </div>
      ) : offer.external ? (
        <a
          className="ws-offer-card__action"
          href={offer.route}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${t(offer.action)} — ${t(offer.title)}`}
        >
          <span>{t(offer.action)}</span>
          <ArrowRight size={18} aria-hidden="true" />
        </a>
      ) : (
        <Link
          className="ws-offer-card__action"
          to={offer.route}
          aria-label={`${t(offer.action)} — ${t(offer.title)}`}
        >
          <span>{t(offer.action)}</span>
          <ArrowRight size={18} aria-hidden="true" />
        </Link>
      )}
    </article>
  );
};

export default OfferCard;
